import { render, staticRenderFns } from "./cotationSolar.vue?vue&type=template&id=961c8b5c&scoped=true&"
import script from "./cotationSolar.vue?vue&type=script&lang=js&"
export * from "./cotationSolar.vue?vue&type=script&lang=js&"
import style0 from "./cotationSolar.vue?vue&type=style&index=0&id=961c8b5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961c8b5c",
  null
  
)

export default component.exports